import React from 'react';
import { useDispatch } from 'react-redux';
import { Field, reduxForm, reset } from 'redux-form';
import { TopBannerComponent } from '../../atoms/atoms.index';
import { required } from '../../../utils/FormValidators';
import { FormattedMessage } from 'react-intl';
import { acceptPolicy } from '../../../store/current-user/current-user.actions';
import { IUser } from '../../../domain/user.interface';
import { EFormName } from '../../../config/form-names.config';
import { CheckboxFieldComponent } from '../../atoms/checkboxField/CheckBoxField.component';
import { policyLink } from '../../../assets/constants/external-links';
import './PolicyPage.component.scss';
import { NavbarComponent } from '../../organisms/organisms.index';

function PolicyPageComponent(props: any) {
  const dispatch = useDispatch();

  function handleResetForm(e: any) {
    e.preventDefault();
    dispatch(reset(EFormName.POLICY));
  }

  function handlePolicy(values: any) {
    dispatch(acceptPolicy(values));
  }

  return (
    <div className='page-container policy-page'>
      <div>
        <NavbarComponent
          showName={true}
          showLogout={true}
          showHelp={true}
          hideBack={true}
          noNavigateHome={true}
        />
        <TopBannerComponent noImage={true} />
      </div>
      <div className='content-wrapper'>
        <form
          onSubmit={props.handleSubmit((values: IUser) => handlePolicy(values))}
        >
          <h4 className='subtitle'>
            <FormattedMessage id='pages.policy-page.title' />
          </h4>
          <div>
            <FormattedMessage id='pages.policy-page.isOfLegalAge'>
              {(txt: any) => (
                <Field
                  name={'isOfLegalAge'}
                  component={CheckboxFieldComponent}
                  validate={[required]}
                  label={txt}
                />
              )}
            </FormattedMessage>
          </div>
          <div>
            <FormattedMessage id='pages.policy-page.legalConditionsAccepted'>
              {(txt: any) => (
                <Field
                  name={'legalConditionsAccepted'}
                  component={CheckboxFieldComponent}
                  validate={[required]}
                  label={txt}
                  info={policyLink}
                />
              )}
            </FormattedMessage>
          </div>
          <section className='form-button-container mt-4'>
            <button
              className='btn-lili danger'
              onClick={(e: any) => handleResetForm(e)}
            >
              <FormattedMessage id='common.cancel' />
            </button>
            <button className='btn-lili' type='submit'>
              <FormattedMessage id='common.save' />
            </button>
          </section>
        </form>
      </div>
    </div>
  );
}

export default reduxForm({
  form: EFormName.POLICY,
})(PolicyPageComponent);
